module.exports = __webpack_public_path__ + "static/media/discord.1780cd06.svg";